var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',_vm._g(_vm._b({ref:"listBoxOption",staticClass:"w-full px-4 py-2 mb-1 rounded text-sm leading-normal listbox-option",class:{
    'listbox-selected-option': _vm.selected,
    'listbox-active-option': _vm.active,
  },attrs:{"role":"option","tabindex":"-1","aria-selected":_vm.selected}},'li',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.option)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }